<template>
  <div>
    <div id="app" v-if="$store.state.websocket">
      <!-- Header -->
      <Navbar/>
      <!-- Page content -->
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
      <!-- Footer -->
      <div class="container">
        <div class="row">
          <div class="col">
            <Footer/>
          </div>
        </div>
      </div>
    </div>
    <div class="shadow" v-else>
      <div class="spinner-border text-primary" style="width: 6rem; height: 6rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
import axios from 'axios'

export default {
  metaInfo: {
    title: 'Monitooring',
    titleTemplate: '%s | Pilv.app'
  },
  components: { Navbar, Footer },
  data () {
    return {
      hostname: null,
      project: null
    }
  },
  watch: {
    '$store.state.project.code': function () {
      // Request groups data from api
      if (this.$store.state.project !== null) {
        // console.log('project code changed to', this.$store.state.project.code)
        this.$store.dispatch('getGroups')
      }
    }
  },
  sockets: {
    connect: function () {
      // console.log('Server connection established')
      this.$socket.emit('setClient', { client: this.project, hostname: this.hostname, token: localStorage.getItem('localToken') })
      this.$store.commit('socketState', true)
    },
    disconnect: function () {
      // console.log('Server connection lost')
      this.$store.commit('socketState', false)
    },
    alarmLog: function (data) {
      // console.log(data)
      // this.$store.commit('updateAlarms', data)
    },
    projectList: function (data) {
      console.log('projectList', data)
      this.$store.commit('setProjects', data)
    },
    projectConfig: function (data) {
      console.log('projectConfig', data)
      this.$store.commit('setProject', data.general)
      this.$store.commit('setStations', data.stations)
      console.log('stationId:', this.$route.params.station_id)
      if (this.$route.params.station_id) {
        // this.$router.push('/view/station/' + this.$route.params.station_id).catch(() => {})
        this.$router.push('/view/station/' + this.$store.state.stations[0].id).catch(() => {})
      } else {
        this.$router.push('/view/station/' + this.$store.state.stations[0].id).catch(() => {})
      }
    }
  },
  created () {
    this.hostname = location.hostname
    this.project = this.hostname.split('.')[0]

    // First thing, check if we need to force SSO login
    axios.get(this.$store.getters.apiUrl + '/isProtected?hostname=' + this.hostname)
      .then((response) => {
        if (response.data.protected === true || this.$route.query.token !== undefined || localStorage.getItem('localToken') !== null) {
          window.protect()
        } else {
          localStorage.setItem('user', JSON.stringify({ name: 'Guest', email: 'guest@pilvepealne.ee', level: 0 }))
        }

        // Set user data
        const _this = this
        setTimeout(function () {
          _this.$store.commit('setUser', JSON.parse(localStorage.getItem('user')))
        }, 500)
      })
      .catch(function (error) {
        console.log('guestMode check error:', error)
      })
  }
}
</script>

<style>
.shadow {
  background-color: #fdfdfe;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
